import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import './TripSelect.css';

// Function to compute service_type based on calendar_data
const getServiceType = (calendarData) => {
    if (!calendarData) return 'Unknown service';

    const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } = calendarData;

    if (monday === 1 && tuesday === 1 && wednesday === 1 && thursday === 1 && friday === 1) {
        return 'Weekday service';
    }
    if (saturday === 1) {
        return 'Saturday service';
    }
    if (sunday === 1) {
        return 'Sunday service';
    }
    if (monday === 0 && tuesday === 0 && wednesday === 0 && thursday === 0 && friday === 0 && saturday === 0 && sunday === 0) {
        return 'Special service';
    }
    return 'Unknown service';
};

const TripSelect = ({
    trips,
    tripsLoading,
    values,
    setFieldValue,
    setTrips,
    setStations,
    searchDebounce,
    fetchRouteTrips,
    fetchRootStopStations,
    onTripMenuScrollToBottom,
    onTripInputChange
}) => {
    // Custom formatOptionLabel to show service_type as a tag
    const formatOptionLabel = ({ label, service_type }) => (
        <div className="trip-option" title={label}>
            {' '}
            {/* Add title for tooltip on hover */}
            <span>{label}</span>
            {service_type && <span className={`service-tag service-tag-${service_type.toLowerCase().replace(' ', '-')}`}>{service_type}</span>}
        </div>
    );

    return (
        <Form.Group className="mb-3">
            <Form.Label>Select Route Trip</Form.Label>
            <Select
                options={trips?.map((trip) => {
                    const departureTime = trip.first_stop?.departure_time 
                        ? trip.first_stop.departure_time.substring(0, 5) 
                        : 'N/A';
                    
                    const tripHeadsign = trip.trip_headsign || '';
                    
                    const departureStation = trip.first_stop?.station_data?.name || 
                                           trip.first_stop?.station_data?.stop_name || 
                                           '';
                    
                    // Build label conditionally
                    let label = `Dep at ${departureTime}`;
                    if (tripHeadsign) {
                        label += ` - ${tripHeadsign}`;
                    }
                    if (departureStation) {
                        label += ` from ${departureStation}`;
                    }
                    
                    return {
                        label: label,
                        value: trip._id,
                    };
                })}
                isLoading={tripsLoading}
                onInputChange={(newValue) => {
                    if (typeof newValue === 'string') {
                        if (onTripInputChange) {
                            onTripInputChange(values?.start_route_id, newValue, setTrips);
                        } else {
                            searchDebounce(values?.start_route_id, newValue, setTrips);
                        }
                    }
                }}
                onMenuScrollToBottom={() => {
                    if (onTripMenuScrollToBottom) {
                        onTripMenuScrollToBottom(values?.start_route_id, setTrips);
                    }
                }}
                onChange={(selectedOption) => {
                    setFieldValue('start_trip_id', selectedOption.value);
                    fetchRouteTrips(values?.start_route_id, selectedOption.label, setTrips);
                    fetchRootStopStations(selectedOption.value, '', setStations);
                }}
                formatOptionLabel={formatOptionLabel}
                placeholder="Select route's trip"
                classNamePrefix="react-select"
                isClearable // Allow clearing selection
                aria-label="Select route trip" // Accessibility
            />
        </Form.Group>
    );
};

export default TripSelect;
